import { useState, useEffect, useRef, ChangeEvent, JSX } from 'react';
import { WidgetProps } from '@rjsf/utils';
import LegendToggleIcon from '@mui/icons-material/LegendToggle';
import { dataStoresOptions } from "./defaults/defaults";
import { Select, MenuItem, SelectChangeEvent } from '@mui/material'

export const NodeDataStoreSelectWidget: (props: WidgetProps) => JSX.Element = (props: WidgetProps): JSX.Element => {
    const { value, onChange, formContext, registry, schema, disabled, uiSchema } = props;

    return (
        <div className="dialog__node-data-management custom-form-widget">
            <div className='node-data-management__controls'>
                <div className="controls__fields">
                    <Select
                        disabled={ disabled }
                        value={value}
                        fullWidth
                        onChange={(e: SelectChangeEvent): void => onChange(e.target.value)} >
                        { dataStoresOptions.map( (store: { id: string, value: string }, index : number) => {

                            let disabled: boolean = false;
                            if (uiSchema !== undefined &&
                                uiSchema['ui:options'] !== undefined &&
                                uiSchema['ui:options'].enumDisabled !== undefined &&
                                uiSchema['ui:options'].enumDisabled.includes(store.id)) {
                                disabled = true;
                            }

                            return (
                                <MenuItem key={ 'data_store_item_' + index  }
                                        disabled={ disabled }
                                        value={ store.id }>
                                    { store.value }
                                </MenuItem>
                            );
                        } ) }
                    </Select>
                </div>
            </div>
        </div>
    );
}
